import { Component, OnInit } from "@angular/core";
import { AuthenticationService } from "../../../../auth/service";
import { UtilsService } from "../../../../auth/service/utils.service";
import { Router } from "@angular/router";
import { locale as italian } from "../../../../i18n/it";
import { CollaboratorsService } from "../../collaborators.service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import moment from "moment-timezone";

@Component({
  selector: "app-list-collaborators",
  templateUrl: "./list-collaborators.component.html",
  styleUrls: ["./list-collaborators.component.scss"],
})
export class ListCollaboratorsComponent implements OnInit {
  public collaborators: any = [];
  public contentHeader: IContentHeader = null;
  public searchKey: string = "";
  public filterCollaborator: any = [];
  public tableLimit: number = 10;
  public filter_type: string = "all";
  filter_contract_start_date = null;
  filter_contract_end_date = null;
  public typeUser: any = ["Stagista", "Partita Iva", "Prestazione Occasionale", "Da Fornitore"];

  constructor(
    public _authenticationService: AuthenticationService,
    public _utilService: UtilsService,
    public _router: Router,
    public _collaboratorsService: CollaboratorsService,
  ) {
    this._utilService.disableAutoHideLoading();
    this.contentHeader = {
      headerTitle: italian.data.TITLES.USERS_TYPES.collaborator,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: false,
            link: "/",
          },
          {
            name: italian.data.MENU.USERS,
            isLink: false,
          },
          {
            name: italian.data.TITLES.USERS_TYPES.collaborator,
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("show_menu_collaborator_list")) {
      this._utilService.hideLoading();
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    await this.loadData();
  }

  async loadData() {
    this.collaborators = await this._collaboratorsService.getCollaboratorList();
    this._utilService.hideLoading();
    await this.searchCollaborator();
  }

  async searchCollaborator() {
    const key: string = this.searchKey.trim().toLowerCase();
    let filteredCollaborators: any = this.collaborators;
    if (key.length > 0) {
      filteredCollaborators = filteredCollaborators.filter((item: any) => {
        return item.complete_name?.toLowerCase().includes(key) || item.email?.toLowerCase().includes(key) || item.business_name?.toLowerCase().includes(key);
      });
    }

    if (this.filter_type !== "all") {
      filteredCollaborators = filteredCollaborators.filter((item: any) => item.type_name === this.filter_type);
    }

    if(this.filter_contract_start_date) {
      const start = moment(this.filter_contract_start_date);
      filteredCollaborators = filteredCollaborators.filter((item: any) => moment(item.start_date) >= start);
    }

    if(this.filter_contract_end_date) {
      const end = moment(this.filter_contract_end_date);
      filteredCollaborators = filteredCollaborators.filter((item: any) => moment(item.end_date) <= end);
    }

    this.filterCollaborator = filteredCollaborators;
  }

  updateTableLimit(event: any) {
    this.tableLimit = Number(event.target.value);
  }

  isDisableCollaborator(user: any) {
    return !user.enable_login;
  }

  async deleteUser(hash: string) {
    if (!this._authenticationService.hasCapability("delete_collaborator")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    await this._utilService
      .showSWAL({
        title: "CONFIRM_DELETE_TITLE",
        text: "CONFIRM_DELETE_USER_TEXT",
        icon: "warning",
        confirmButtonText: "CONFIRM_DELETE_BTN",
        customClass: {
          confirmButton: "btn btn-danger",
        },
      })
      .then(async (result) => {
        if (result.value) {
          await this._collaboratorsService.deleteCollaborator(hash).then(async () => {
            await this._utilService.showPopupItemDeleted("DELETED_USER_TEXT").then(() => window.location.reload());
          });
        }
      });
  }

  async disableUser(hash: string) {
    if (!this._authenticationService.hasCapability("edit_collaborator")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    this._utilService.showLoading();
    await this._collaboratorsService
      .disableLogin(hash)
      .then(async () => {
        await this.loadData();
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_DISABLE_USER" });
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_DISABLE_USER" });
      });
  }

  async enableUser(hash: string) {
    if (!this._authenticationService.hasCapability("edit_collaborator")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    this._utilService.showLoading();
    await this._collaboratorsService
      .enableLogin(hash)
      .then(async () => {
        await this.loadData();
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_ENABLE_USER" });
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_ENABLE_USER" });
      });
  }

  async transformCollaborateToEmployee(collaborator: any) {
    await this._router.navigateByUrl("/dashboard/transformation-create/" + collaborator.hash);
  }
}
